export default __webpack_public_path__ + "static/prudential-e728a4735b84b90ba75021893d4f358d.png";